import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import {Box,Card,Slider,List,Button,Paper,FormControlLabel,Radio, ListItem, Divider, Grid,RadioGroup,Link,LinearProgress,Checkbox,Popover,IconButton} from '@material-ui/core';
import alipayimg from '../../images/alipay.png'
import alipayimg_icon from '../../images/alipay_icon.png'
import wxpayimg from '../../images/wxpay.png'
import wxpayimg_icon from '../../images/wxpay_icon.png'
import help from '../../images/help.jpeg'
import paypalimg from '../../images/paypal.png'
import BookmarkIcon from '@material-ui/icons/Bookmark';
import WatchLaterIcon from '@material-ui/icons/WatchLater';
import PersonIcon from '@material-ui/icons/Person';
import {writelog,handleError,getLocalUsrInfo,getApiDomain} from '../../utils'
import bakimg from '../../images/background.png'
import HelpIcon from '@material-ui/icons/Help';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    'aria-controls': `vertical-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: '#FFFFFF',//theme.palette.background.paper,
    display: 'flex',
    height: 384,
    textAlign:"center",
    paddingTop:2
  },
  tabs: {
    borderRight: `1px solid ${theme.palette.divider}`,
  },
  paper: {
    height: 164,
    width: 196,
    paddingTop: 32
  },
}));

export default function Pay(props) {
  const classes = useStyles();
  const [tabvalue, setTabValue] = React.useState(props.tabvalue);
  const [usrtype, setUsrType] = React.useState(props.usrInfo.VIP);
  const [buyHour, setBuyHour] = React.useState(props.buyHour)
  const [awardHour, setAwardHour] = React.useState(props.awardHour)
  const [paying,setPaying] = React.useState(false)
  const [upgrade,setUpgrade] = React.useState(props.upgrade)
  const [anchorEl, setAnchorEl] = React.useState(null);


  const handleUsrTypeHelp = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleUsrTypeHelpClose = () => {
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;


  const handleUpgrade = (event,newValue) => {
    setUpgrade(newValue)
    props.setUpgrade(newValue)
  }

  const handleChange = (event, newValue) => {
    setTabValue(newValue);
    props.setTabValue(newValue)
  };

  const handleBuyHour = (event, newValue) => {
      setBuyHour(newValue)
      props.setBuyHour(newValue)
      var total = newValue*props.standardPrice
      props.setTotalAmount(Math.round(total*Math.pow(10,1))/Math.pow(10,1))
      var newAwd = 0 
      if(props.usrInfo.VIP == 1){
        props.vipAwards.map(element=>{
          if(newValue>=element.count){
            newAwd = newValue*(element.rate-1)
          }
        })
      } else {
        props.svipAwards.map(element=>{
          if(newValue>=element.count){
            newAwd = newValue*(element.rate-1)
          }
        })
      }
      setAwardHour(Math.round(newAwd*Math.pow(10,1))/Math.pow(10,1))
      props.setAwardHour(Math.round(newAwd*Math.pow(10,1))/Math.pow(10,1))
      props.setRealPrice(Math.round((total/(newAwd+newValue))*Math.pow(10,1))/Math.pow(10,1))
  }

  const handleSub = async (plan) => {
    setPaying(true)

    var usr = getLocalUsrInfo()
    var reqData ={
      UID: usr.UserID,
      Plan: plan,
      Channel: 33
    }
    let response = await fetch(getApiDomain()+'/users/CreateSub/'+usr.UserID+'?rnd='+Math.random()*999,{
        method: 'POST',
        headers: {
            'Content-Type': 'application/json;charset=utf-8',
            'sessionid': usr.SessionID
        },
        body: JSON.stringify(reqData)
    }).catch(handleError);
    //writelog("handleSub call",reqData,response.ok)
    if(response.ok){
        let resData = await response.json();
        if(resData.Result ==0) {
          window.location.href = resData.TradeLink
          //console.log(resData.TradeLink)
        } else {
            writelog("handleSub","resData fail",resData)
        }
    } else {
        writelog("handleSub","response fail",response)
    }
    setTimeout(setPaying,5000,false)
  }

  const handleSub2 = async (plan,chid) => {
    setPaying(true)

    var cid =0
    if(chid == "wxpay"){
     cid = 11
    } else if(chid == "alipay") {
      cid = 0
    } else if(chid == "paypal"){
      cid = 3 
    }
    var usr = getLocalUsrInfo()
    var reqData ={
      UID: usr.UserID,
      Plan: plan,
      Channel: cid
    }
    let response = await fetch(getApiDomain()+'/users/CreateSub2/'+usr.UserID+'?rnd='+Math.random()*999,{
        method: 'POST',
        headers: {
            'Content-Type': 'application/json;charset=utf-8',
            'sessionid': usr.SessionID
        },
        body: JSON.stringify(reqData)
    }).catch(handleError);
    //writelog("handleSub call",reqData,response.ok)
    if(response.ok){
        let resData = await response.json();
        if(resData.Result ==0) {
          props.setTradeNo(resData.OutTradeNo)

          if(chid == "wxpay"){
            props.setPayQRImg(resData.QRImage)
            window.location.href="#/qrpay"

          } else if(chid == "alipay") {
            props.setPayQRImg(resData.QRImage)
            window.location.href="#/qrpay"

          } else if(chid == "paypal"){
            window.location.href = resData.TradeInfo

          }
        } else {
            writelog("handleSub","resData fail",resData)
        }
    } else {
        writelog("handleSub","response fail",response)
    }
    setTimeout(setPaying,2000,false)
  }

  const handlUsrChange = (event, newValue) => {
      setUsrType(newValue)
  }

  const contact = (event) => {

  }

  const handlePay = async () => {

    setPaying(true)

    var chid = 11
    if(props.PayChannel == "wxpay"){
      chid = 11
    } else if(props.PayChannel == "alipay") {
      chid = 0
    } else if(props.PayChannel == "paypal"){
      chid = 3
    }
    var usr = getLocalUsrInfo()
    var reqData ={
      UserID: usr.UserID,
      Price: parseFloat(props.realPrice),
      LiveTime: Math.round(buyHour+awardHour),
      Total: parseFloat(props.totalAmount),
      Channel: chid,
      AcceptUpgrade: upgrade
    }

    let response = await fetch(getApiDomain()+'/users/CreateTrade/'+usr.UserID+'?rnd='+Math.random()*999,{
        method: 'POST',
        headers: {
            'Content-Type': 'application/json;charset=utf-8',
            'sessionid': usr.SessionID
        },
        body: JSON.stringify(reqData)
    }).catch(handleError);
    //writelog("handlePay call",reqData,response.ok)
    if(response.ok){
        let resData = await response.json();
        //console.log("handlePay:",resData)
        if(resData.Result ===0) {

          props.setTradeNo(resData.OutTradeNo)

          if(props.PayChannel == "wxpay"){
            props.setPayQRImg(resData.QRImage)
            window.location.href="#/qrpay"

          } else if(props.PayChannel == "alipay") {
            props.setPayQRImg(resData.QRImage)
            window.location.href="#/qrpay"

          } else if(props.PayChannel == "paypal"){

            window.location.href = resData.TradeInfo
          }
        } else {
            writelog("handlePay","resData fail",resData)
        }
    } else {
        writelog("handlePay","response fail",response)
        //console.log("handlePay response:",response)
    }
    setPaying(false)
  }

  return (
    <div className={classes.root} style={{backgroundImage:`url(${bakimg})`}}>
      <Tabs
        orientation="vertical"
        variant="scrollable"
        value={tabvalue}
        onChange={handleChange}
        aria-label="Vertical tabs example"
        className={classes.tabs}
      >
        <Tab disabled={paying} label="小时模式" {...a11yProps(0)} />
        <Tab disabled={paying} label="包月模式" {...a11yProps(1)} />
        
      </Tabs>

      <TabPanel value={tabvalue} index={1}>
        <Typography paragraph="true" variant="h5" style={{padding:16,fontWeight:"bold"}} color="primary">{props.usrInfo.SubPlan ==""?"选择您的计划":"改变您的计划"}</Typography>
        <Grid container justify="center" spacing={3}>
            <Grid key={tabvalue} item >
                <Paper className={classes.paper}>
                    <Typography variant="h6" style={{color:"rgb(209, 75, 13)",fontWeight:"bold"}}>$14.98/月</Typography>
                    <Typography variant="body2" style={{padding:8,fontWeight:"bold"}}>包月</Typography>
                    <Typography variant="body1" style={{padding:8,fontWeight:"bold",color:"#2E8B57",fontSize: 12}}>最大码率:5000k</Typography>
                    <Divider style={{margin:10}}></Divider>
                    <IconButton disabled={paying} aria-label="delete" className={classes.margin} style={{height:8,width:8,color:"#B1B1B1",horizontal:"center",margin:8}} onClick={()=>{handleSub2("1 Month","wxpay")}}>
                      <img  src={wxpayimg_icon} width="16" height="16"></img>
                    </IconButton>
                    <Button disabled={paying /*|| props.usrInfo.SubPlan == "1 Month"*/} variant="outlined" size="small" style={{fontWeight:"bold"}} onClick={()=>{handleSub("1 Month")}} >订阅</Button>
                    <IconButton disabled={paying} aria-label="delete" className={classes.margin} style={{height:8,width:8,color:"#B1B1B1",horizontal:"center",margin:8}} onClick={()=>{handleSub2("1 Month","alipay")}}>
                      <img  src={alipayimg_icon} width="16" height="16"></img>
                    </IconButton>
                </Paper>
            </Grid>
            <Grid variant="outlined" key={tabvalue} item>
                <Paper  className={classes.paper} style={{paddingTop:32,marginTop:-16,height:188,paddingTop:24}}>
                    <BookmarkIcon style={{color:"#ffd700",fontSize: 20}}></BookmarkIcon>
                    <Typography variant="h6" style={{color:"rgb(209, 75, 13)",fontWeight:"bold"}}>$9.98/月</Typography>
                    <Typography variant="body1" style={{padding:8,fontWeight:"bold"}}>包年</Typography>
                    <Typography variant="body1" style={{padding:8,fontWeight:"bold",color:"#008000",fontSize: 14}}>最大码率:8000k</Typography>
                    <Divider style={{margin:6}}></Divider>
                    <IconButton disabled={paying} aria-label="delete" className={classes.margin} style={{height:8,width:8,color:"#B1B1B1",horizontal:"center",margin:8}} onClick={()=>{handleSub2("12 Month","wxpay")}}>
                      <img  src={wxpayimg_icon} width="16" height="16"></img>
                    </IconButton>
                    <Button disabled={paying /*|| props.usrInfo.SubPlan == "12 Month"*/} variant="contained" size="small" color="primary" style={{fontWeight:"bold"}} onClick={()=>{handleSub("12 Month")}} >订阅</Button>
                    <Button variant="contained" size="small" color="primary" style={props.TestMode == null?{fontWeight:"bold",display:"none"}:{fontWeight:"bold"}} onClick={()=>{handleSub(props.TestMode)}} >测试</Button>
                    <IconButton disabled={paying} aria-label="delete" className={classes.margin} style={{height:8,width:8,color:"#B1B1B1",horizontal:"center",margin:8}} onClick={()=>{handleSub2("12 Month","alipay")}}>
                      <img  src={alipayimg_icon} width="16" height="16"></img>
                    </IconButton>
                </Paper>
            </Grid>
            <Grid key={tabvalue} item>
                <Paper className={classes.paper} >
                    <Typography variant="h6" style={{color:"rgb(209, 75, 13)",fontWeight:"bold"}}>$12.98/月</Typography>
                    <Typography variant="body2" style={{padding:8,fontWeight:"bold"}}>包半年</Typography>
                    <Typography variant="body1" style={{padding:8,fontWeight:"bold",color:"#2E8B57",fontSize: 12}}>最大码率:5000k</Typography>
                    <Divider style={{margin:10}}></Divider>
                    <IconButton disabled={paying} aria-label="delete" className={classes.margin} style={{height:8,width:8,color:"#B1B1B1",horizontal:"center",margin:8}} onClick={()=>{handleSub2("6 Month","wxpay")}}>
                      <img  src={wxpayimg_icon} width="16" height="16"></img>
                    </IconButton>
                    <Button disabled={paying /*|| props.usrInfo.SubPlan == "6 Month"*/} variant="outlined" size="small" style={{fontWeight:"bold"}} onClick={()=>{handleSub("6 Month")}}>订阅</Button>    
                    <IconButton disabled={paying} aria-label="delete" className={classes.margin} style={{height:8,width:8,color:"#B1B1B1",horizontal:"center",margin:8}} onClick={()=>{handleSub2("6 Month","alipay")}}>
                      <img  src={alipayimg_icon} width="16" height="16"></img>
                    </IconButton>
  
                </Paper>
            </Grid>
        </Grid>
        <LinearProgress style={paying?{marginTop:8}:{display:"none"}} />

        <Typography style={{paddingTop:16,fontSize:12,color:"#2E8B57"}}>温馨提示:</Typography>
        <Typography style={{fontSize:6,color:"#2E8B57"}}> 支持paypal和信用卡支付。任意时间都可以开始一个周期的订阅，自动续订。</Typography>
        <Typography style={{fontSize:6,color:"#2E8B57"}}> 取消订阅请在下个周期续费前，通过paypal账户自行取消。</Typography>
        <Typography style={{fontSize:6,color:"#2E8B57"}}> 如果您无法通过paypal支付，也可以联系客服直接帮您通过微信/支付宝支付。</Typography>
        
        
       
      </TabPanel>
      
      <TabPanel value={tabvalue} index={0} style={{marginTop:-16}}>
        <Card style={{width:280,height:196,padding:16,paddingBottom:24}}>
            <Box style={{display:"flex",paddingLeft:16}}>
                <WatchLaterIcon style={{color:"#ffd700",fontSize:14}}></WatchLaterIcon>
                <Typography variant="body2" color="primary" style={{fontSize:8,}}>
                    剩余播时: {props.usrInfo.LeftLiveTime} 
                </Typography>
                <Box style={{width:24}}></Box>
                <PersonIcon style={{color:"#ffd700",fontSize:14}}></PersonIcon>
                <Typography variant="body2" color="primary" style={{fontSize:8,}}>
                    新购总计: {buyHour+awardHour} 播时
                </Typography>
            </Box>
            
            <Typography variant="h5" style={{color:"rgb(209, 75, 13)",padding:24,paddingBottom:16,fontWeight:"bold"}}>
                金额: {props.totalAmount} 元
            </Typography>
            <Typography variant="body2" >
                (标准单价: {props.standardPrice} 元/播时)
            </Typography>
            <Slider disabled={paying} valueLabelDisplay="auto" step={5} min={0} max={300} value={buyHour} onChange={handleBuyHour} aria-labelledby="continuous-slider" style={{paddingTop:48}}/>
            <Box style={{display:"flex",marginLeft:-8,flexDirection: "row",justifyContent: "center"}}>
              <Typography variant="body2" style={awardHour<=0?{display:"none"}:{color:"rgb(209, 75, 13)",fontSize:8,}}>
                  恭喜 赠送您 {awardHour} 播时 (实际单价: {props.realPrice})
              </Typography>

            </Box>
            <Box style={{display:"flex",marginLeft:-8,flexDirection: "row",justifyContent: "center",paddingTop:4}}>
              <Checkbox checked={upgrade} onChange={handleUpgrade} name="upgrade" style={props.usrInfo.TotalLiveTime+awardHour < 300?{display:"none"}:{transform: "scale(0.4)",marginTop:-11,color:"#B1B1B1"}} />
              <Typography style={props.usrInfo.TotalLiveTime+awardHour < 300 ?{display:"none"}:{color:"#B1B1B1",fontSize:2,marginLeft:-10}}>
                {props.usrInfo.VIP == 1?"升 SVIP (4.98元/播时)":"转 VIP"}
              </Typography>
              <IconButton aria-label="delete" className={classes.margin} style={{height:8,width:8,color:"#B1B1B1",horizontal:"center",marginBottom:4}} onClick={handleUsrTypeHelp}>
                <HelpIcon style={{height:10,width:10,color:"#B1B1B1",horizontal:"top",marginBottom:4}} />
              </IconButton>
              <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleUsrTypeHelpClose}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'center',
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'center',
                }}
              >
                <img  src={help} width="300" height="485"></img>              </Popover>
            </Box>

        </Card>
        <Divider></Divider>
        <Card style={{padding:8,paddingBottom:16,paddingTop:0}}>
            <List>
                <ListItem style={{height:48}}>
                    <Radio disabled={paying} checked={props.PayChannel == "wxpay"} onChange={()=>{props.setPayChannel("wxpay")}}></Radio>
                    <img  src={wxpayimg} width="96" height="24"></img>
                </ListItem>
                <ListItem disabled={paying} style={{height:48}}>
                    <Radio checked={props.PayChannel == "alipay"} onChange={()=>{props.setPayChannel("alipay")}}></Radio>
                    <img src={alipayimg} width="60" height="24"></img>
                </ListItem>
                <ListItem style={{height:48}}>
                    <Radio disabled={paying} checked={props.PayChannel == "paypal"} onChange={()=>{props.setPayChannel("paypal")}}></Radio>
                    <img src={paypalimg} width="79" height="20"></img>
                </ListItem>
            </List>
            <Divider style={{paddingLeft:40,paddingRight:40,marginBottom:8}}></Divider>
            <Button disabled={paying || buyHour == 0 } variant="contained" color="primary" onClick={handlePay}>
                支付
            </Button>
            <LinearProgress style={paying?{marginTop:8}:{display:"none"}} />
            
        </Card>
        <Typography style={{paddingTop:16,fontSize:12,color:"#2E8B57",display:"none"}}>最新活动</Typography>
        <Typography style={{fontSize:6,display:"none"}}> 发5星好评并留言，截图给客服,可获赠3～10个免费播时</Typography>
        <Typography style={{fontSize:10,display:"none"}}> </Typography>
        <Link style={{fontSize:10,color:"blue",display:"none"}} target="_blank" href="https://chrome.google.com/webstore/detail/%E5%B0%8F%E4%B9%8C%E9%BE%9F%E5%A4%9A%E6%92%AD-%E6%B5%B7%E5%A4%96%E8%BD%BB%E6%9D%BE%E7%9B%B4%E6%92%ADbilibili%E5%93%94%E5%93%A9%E5%93%94%E5%93%A9/ffncmmojkoefikplldmnhnogbakllmhg?hl=en">
          去留言
        </Link>
        
      </TabPanel>
      
      <TabPanel value={tabvalue} index={2} style={{marginTop:-32}}>
        <Card style={{margin:16,padding:16,width:160}}>
            <RadioGroup value={usrtype} onChange={handlUsrChange}>
                <FormControlLabel size="small" value="1" control={<Radio />} label="VIP" />
                <FormControlLabel size="small" value="2" control={<Radio />} label="SVIP" />
            </RadioGroup>
            <Divider></Divider>
            <Button variant="contained" color="primary" size="small" style={{marginTop:16}}>提交</Button>
        </Card>
        <Typography variant="body2">您还有5次切换用户级别的机会</Typography>
        <Link href="#" onClick={contact} style={{fontSize:8,color:"#B1B1B1"}}>联系客服</Link>
      </TabPanel>
    </div>
  );
}
